<div class="login-block">
  <div class="container pt-5">
    <div class="card flex-grow-1 mb-2">
      <div class="card-body">
        <div class="logo">
          <img src="/assets/tyre-buzzar-logo.png" alt="Tyre Buzzar Logo" width="100" />
        </div>
        @if (welRegHeader) {
        <div class="header">
          <P>Welcome to Registration process of TyBu
          </P>
        </div>
        }
        @if (subRegHeader) {
        <div class="sub-header">
          <P>Registration on this platform should be done by an authorized
            person (Director of the organisation or a Key Person). Please read
            and agree to the Terms & Conditions of TyBu before Sign Up.</P>
        </div>
        }

        @if (showForm1) {
        <form [formGroup]="regFormOne" class="p-3" (ngSubmit)="saveRegisterData()">
          <h3>Company Details:</h3>
          <div class="row g-3 mb-3">
            <div class="col-12 col-md-4">
              <input formControlName="name" id="name" class="form-control form-control-lg default-form-group-border"
                placeholder="Company name*" required [readonly]="otpSent || otpVerified" />
              @if (regFormOne.get('name')?.invalid && (regFormOne.get('name')?.dirty ||
              regFormOne.get('name')?.touched)) {
                <div class="errorText">
                  @if (regFormOne.get('name')?.errors?.['required']) {
                    <small class="text-danger">Please enter company name</small>
                  }
                </div>
              }
            </div>
            <div class="col-12 col-md-4">
              <input formControlName="email" id="email"
                class="form-control form-control-lg default-form-group-border" placeholder="Company email" [readonly]="otpSent || otpVerified" />
              @if (regFormOne.get('email')?.invalid && (regFormOne.get('email')?.dirty ||
              regFormOne.get('email')?.touched)) {
                <div class="errorText">
                  @if (regFormOne.get('email')?.errors?.['pattern']) {
                    <small class="text-danger">Please enter valid mail address</small>
                  }
                </div>
              }
            </div>
            <div class="col-12 col-md-4">
              <input formControlName="phoneNumber" id="phoneNumber"
                class="form-control form-control-lg default-form-group-border" placeholder="Phone number"
                type="number" (input)="input($event)" [readonly]="otpSent || otpVerified" />
              @if (regFormOne.get('phoneNumber')?.invalid && (regFormOne.get('phoneNumber')?.dirty ||
              regFormOne.get('phoneNumber')?.touched)) {
                <div class="errorText">
                  @if (regFormOne.get('phoneNumber')?.errors?.['pattern']) {
                    <small class="text-danger">Please enter valid mobile number</small>
                  }
                </div>
              }
            </div>
            <div class="col-12 col-md-4">
              <input formControlName="ownerName" id="ownerName"
                class="form-control form-control-lg default-form-group-border" placeholder="Owner name" [readonly]="otpSent || otpVerified" />
            </div>
            <div class="col-12 col-md-4" formGroupName="companyInformation">
              <input formControlName="gstin" id="gstin" class="form-control form-control-lg default-form-group-border"
                placeholder="GSTIN" maxlength="15" minlength="15" [readonly]="otpSent || otpVerified" />
            </div>
            <div class="col-12 col-md-4" formGroupName="companyInformation">
              <input formControlName="pan" id="pan " class="form-control form-control-lg default-form-group-border"
                placeholder="PAN" maxlength="10" minlength="10" [readonly]="otpSent || otpVerified" />
            </div>
          </div>

          <h3>Address:</h3>
          <div class="col-12 mb-3" formGroupName="address">
            <div class="row g-3">
              <div class="col-12 col-md-4">
                <input type="text" class="form-control form-control-lg default-form-group-border" formControlName="line1" id="line1"
                  required placeholder="Address line 1*" [readonly]="otpSent || otpVerified">
                @if (regFormOne.get('address.line1')?.invalid && regFormOne.get('address.line1')?.touched) {
                  <div>
                    <small class="text-danger">Please enter address line1</small>
                  </div>
                }
              </div>
              <div class="col-12 col-md-4">
                <input type="text" class="form-control form-control-lg default-form-group-border" formControlName="line2" id="line2"
                  placeholder="Address line 2" [readonly]="otpSent || otpVerified">
              </div>
              <div class="col-12 col-md-4">
                <input type="text" class="form-control form-control-lg default-form-group-border" formControlName="city" id="city"
                  placeholder="City" [readonly]="otpSent || otpVerified">
              </div>
              <div class="col-12 col-md-4">
                <input type="text" class="form-control form-control-lg default-form-group-border" formControlName="state" id="state"
                  placeholder="Enter state" [readonly]="otpSent || otpVerified">
              </div>
              <div class="col-12 col-md-4">
                <input type="text" class="form-control form-control-lg default-form-group-border" formControlName="country" id="country"
                  placeholder="Country" [readonly]="otpSent || otpVerified">
              </div>
              <div class="col-12 col-md-4">
                <input type="text" class="form-control form-control-lg default-form-group-border" formControlName="pincode" id="pincode"
                  placeholder="PIN code" maxlength="6" [readonly]="otpSent || otpVerified">
              </div>
            </div>
          </div>

          <h3>Login Details:</h3>
          <div class="row g-3 align-items-start mb-3">
            <div class="col-12 col-md-4">
              <input formControlName="userName" id="userName"
                class="form-control form-control-lg default-form-group-border" placeholder="User name*" required [readonly]="otpSent || otpVerified" />
              @if (regFormOne.get('userName')?.invalid && (regFormOne.get('userName')?.dirty ||
              regFormOne.get('userName')?.touched)) {
                <div class="errorText">
                  @if (regFormOne.get('userName')?.errors?.['required']) {
                    <small class="text-danger">Please enter user name</small>
                  }
                </div>
              }
            </div>
            <div class="col-12 col-md-4">
              @if (!otpSent && !otpVerified) {
                <input formControlName="userPhoneNumber" id="userPhoneNumber"
                  class="form-control form-control-lg default-form-group-border" placeholder="Phone number*" required
                  type="number" (input)="onInput($event)" />
                @if (regFormOne.get('userPhoneNumber')?.invalid && (regFormOne.get('userPhoneNumber')?.dirty ||
                regFormOne.get('userPhoneNumber')?.touched)) {
                  <div class="errorText">
                    @if (regFormOne.get('userPhoneNumber')?.errors?.['pattern']) {
                      <small class="text-danger">Please enter valid mobile number</small>
                    }
                    @if (regFormOne.get('userPhoneNumber')?.errors?.['required']) {
                      <small class="text-danger">Mobile number is required</small>
                    }
                  </div>
                }
              } @else if (otpSent && !otpVerified) {
                <input formControlName="otp" id="otp"
                  class="form-control form-control-lg default-form-group-border" placeholder="Enter OTP*" required
                  type="number" (input)="onOtpInput($event)" />
                <div class="mt-1">
                  <small class="text-muted">Enter the 6-digit OTP sent to your phone number</small>
                </div>
                @if (regFormOne.get('otp')?.invalid && (regFormOne.get('otp')?.dirty || regFormOne.get('otp')?.touched)) {
                  <div class="errorText">
                      @if (regFormOne.get('otp')?.errors?.['pattern']) {
                        <small class="text-danger">OTP must be exactly 6 digits</small>
                      }
                  </div>
                }
              } @else if (otpVerified) {
                <input [value]="regFormOne.get('userPhoneNumber')?.value"
                  class="form-control form-control-lg default-form-group-border" readonly disabled />
              }
            </div>
            <div class="col-12 col-md-4">
              @if (!otpSent && !otpVerified) {
                <button type="button" class="btn app-btn-primary w-100" style="height: calc(1.5em + 1rem + 2px);" [disabled]="!isVerifyEnabled || isOtpLoading" (click)="sendOtp()">
                  Verify
                  @if (isOtpLoading) {
                    <output class="spinner-border spinner-border-sm ms-1" aria-hidden="true"></output>
                  }
                </button>
              } @else if (otpSent && !otpVerified) {
                <button type="button" class="btn app-btn-primary w-100" style="height: calc(1.5em + 1rem + 2px);" [disabled]="regFormOne.get('otp')?.invalid || verifyingOtp" (click)="verifyOtp(regFormOne.get('otp')?.value)">
                  Verify OTP
                  @if (verifyingOtp) {
                    <output class="spinner-border spinner-border-sm ms-1" aria-hidden="true"></output>
                  }
                </button>
              } @else if (otpVerified) {
                <button type="button" class="btn btn-success w-100" style="height: calc(1.5em + 1rem + 2px);" disabled>
                  Verified
                </button>
              }
            </div>
          </div>

          <div class="row pt-3 align-items-center">
            <div class="col-12 col-md-8 terms-conditions mb-2 mb-md-0">
              <input formControlName="checkbox" type="checkbox" class="cursor-pointer" /> I accept
              the TyBu
              <a (click)="openPopup()" target="_blank">Terms and Conditions</a>
            </div>
            <div class="col-12 col-md-4 text-md-end text-center">
              <button type="button" class="btn btn-outline-dark m-2" [routerLink]="'/login'">Cancel</button>
              <button type="submit" class="btn app-btn-primary" [disabled]="regFormOne.invalid || !otpVerified || isLoading">Submit
                @if (isLoading) {
                <output class="spinner-border spinner-border-sm" aria-hidden="true"></output>
                }
              </button>
            </div>
          </div>
          <div>
            <small class="text-center text-danger">{{ errorMessage }}</small>
          </div>
        </form>
        }
        @if (showForm2) {
        <form class="p-3">
          <div class="row">
            <div class="col-12">
              <h3>Congratulations!</h3>
              <p>Registration completed.</p>
              <p><a [routerLink]="['/login']" class="text-link">Sign In</a></p>
            </div>
          </div>
        </form>
        }
        @if (welRegHeader) {
        <div class="reg-text text-center">
          Already Registered? <a [routerLink]="['/login']" class="text-link">Sign In</a>
        </div>
        }
        <ng-template #content let-modal class="popup-box">
          <div class="modal-header">
            <h3 class="modal-title">Terms and Conditions</h3>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body scroll">
            <h3>Consectetur adipiscing elits</h3>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
              labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
              laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in
              voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
              cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
            <h3>Consectetur adipiscing elits</h3>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
              labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
              laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in
              voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
              cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
              labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
              laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in
              voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
              cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn app-btn-green" (click)="modal.close()">Close</button>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>